import * as type from './DrugType';

const initialState = {
    prescriptions: null,
    drugs: null
};
export const drugReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.SET_PRESCRIPTIONS.SUCCESS:
            return { ...state, prescriptions: action.payload };
        case type.ADD_PRESCRIPTION: {
            const newList = [action.payload, ...state.prescriptions].sort(
                (a, b) => new Date(b.prescribed) - new Date(a.prescribed)
            );
            return { ...state, prescriptions: newList };
        }
        case type.REMOVE_PRESCRIPTION:
            return {
                ...state,
                prescriptions: state.prescriptions.filter((val) => val.id !== action.payload)
            };
        case type.REPLACE_PRESCRIPTION: {
            const id = action.payload.id;
            const data = action.payload.data;
            const index = state.prescriptions.findIndex((val) => val.id === id);
            const newPrescriptions = [
                ...state.prescriptions.slice(0, index),
                data,
                ...state.prescriptions.slice(index + 1)
            ];
            return {
                ...state,
                prescriptions: newPrescriptions
            };
        }

        case type.SET_DRUGS:
            return {
                ...state,
                drugs: { ...state.drugs, [action.payload.key]: action.payload.data }
            };
        default:
            return state;
    }
};
